import ApiClient from '../apiClient/ApiClient'

const apiClient = new ApiClient()

/**
 * Update the user's language preference in the database
 * @param lang - Language code ('en', 'fr', 'de', 'it')
 */
export const updateUserLanguage = async (lang: string): Promise<void> => {
  try {
    await apiClient.put('/users/me', { lang })
  } catch (error) {
    console.error('Failed to update language preference:', error)
  }
}
